import * as Scrivito from "scrivito"
import { defaultPageAttributes } from "scrivito/Objs/shared/defaultAttributes"

export const TeamsOverviewPageObjClass = Scrivito.provideObjClass(
  "TeamsOverviewPage",
  {
    attributes: {
      ...defaultPageAttributes,
      data: "datalocator"
    },
    extractTextAttributes: ["body"]
  }
)
export type TeamsOverviewPage = InstanceType<typeof TeamsOverviewPageObjClass>
